import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import "./assets/buttons.css"; // 共通ボタン（.btn-primary / .btn-ghost / .btn-icon）

loadFonts();

createApp(App).use(router).use(vuetify).mount("#app");
